module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-move-3fcbfd1dccbe3b74e3c034386140b0da.svg";